function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null);

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0.207692308,7.7 C0.0692307692,7.56 0,7.35 0,7.21 C0,7.07 0.0692307692,6.86 0.207692308,6.72 L1.17692308,5.74 C1.45384615,5.46 1.86923077,5.46 2.14615385,5.74 L2.21538462,5.81 L6.02307692,9.94 C6.16153846,10.08 6.36923077,10.08 6.50769231,9.94 L15.7846154,0.21 L15.8538462,0.21 L15.8538462,0.21 C16.1307692,-0.07 16.5461538,-0.07 16.8230769,0.21 L17.7923077,1.19 C18.0692308,1.47 18.0692308,1.89 17.7923077,2.17 L17.7923077,2.17 L6.71538462,13.79 C6.57692308,13.93 6.43846154,14 6.23076923,14 C6.02307692,14 5.88461538,13.93 5.74615385,13.79 L0.346153846,7.91 L0.207692308,7.7 Z",
  id: "icon-tick",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}));

const SvgTick = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "14px",
    viewBox: "0 0 18 14",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgTick, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tick.b2b2c025.svg";
export { ForwardRef as ReactComponent };